import React, { Component, Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS } from "../utils/init";
import { withRouter } from "react-router-dom";
import {
  GetAllProducts,
  RegisterProducts,
  UploadProductImage,
} from "../utils/service";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import PageHeader from "../components/PageHeader";
import { showToast, showHttpError, formatAmount } from "../utils/library";

/* ─── Inline styles ─────────────────────────────────────────────────────── */
const styles = {
  pageWrapper: { padding: "36px 24px 60px" },
  headerRow: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    marginBottom: "28px", flexWrap: "wrap", gap: "16px",
  },
  btnPrimary: {
    display: "inline-flex", alignItems: "center", gap: "8px",
    padding: "10px 24px", background: "var(--btn-color)", color: "#fff",
    border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600",
    cursor: "pointer", transition: "all 0.2s ease", whiteSpace: "nowrap",
  },
  btnSecondary: {
    display: "inline-flex", alignItems: "center", gap: "8px",
    padding: "8px 16px", background: "var(--body-color-less2)", color: "var(--text-color)",
    border: "1px solid var(--body-color-less2)", borderRadius: "8px",
    fontSize: "12px", fontWeight: "600", cursor: "pointer", transition: "all 0.2s ease",
  },
  card: {
    background: "var(--body-color-less)", borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)", overflow: "hidden",
  },
  tableWrapper: { overflowX: "auto" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: {
    padding: "14px 16px", fontSize: "11px", fontWeight: "700",
    textTransform: "uppercase", letterSpacing: "0.5px",
    color: "var(--text-color)", opacity: 0.5,
    borderBottom: "1px solid var(--body-color-less2)",
    textAlign: "left", whiteSpace: "nowrap", background: "var(--body-color-less)",
  },
  td: {
    padding: "14px 16px", fontSize: "13px",
    borderBottom: "1px solid var(--body-color-less2)",
    verticalAlign: "middle", whiteSpace: "nowrap",
  },
  productImage: {
    width: "40px", height: "40px", borderRadius: "8px",
    objectFit: "cover", background: "var(--body-color-less2)",
  },
  productImagePlaceholder: {
    width: "40px", height: "40px", borderRadius: "8px",
    background: "var(--body-color-less2)", display: "flex",
    alignItems: "center", justifyContent: "center",
    fontSize: "18px",
  },
  statusBadge: (status) => ({
    display: "inline-flex", alignItems: "center", gap: "5px",
    padding: "4px 12px", borderRadius: "20px", fontSize: "11px", fontWeight: "600",
    background: status === "ACTIVE" ? "rgba(16,185,129,0.1)" : status === "DRAFT" ? "rgba(245,158,11,0.1)" : "rgba(107,114,128,0.1)",
    color: status === "ACTIVE" ? "#10b981" : status === "DRAFT" ? "#f59e0b" : "#6b7280",
  }),
  statusDot: (status) => ({
    width: "6px", height: "6px", borderRadius: "50%",
    background: status === "ACTIVE" ? "#10b981" : status === "DRAFT" ? "#f59e0b" : "#6b7280",
  }),
  actionBtnEdit: {
    display: "inline-flex", alignItems: "center", gap: "5px",
    padding: "6px 14px", background: "transparent",
    color: "var(--btn-color)", border: "1px solid var(--btn-color)",
    borderRadius: "8px", fontSize: "12px", fontWeight: "600",
    cursor: "pointer", transition: "all 0.2s ease", marginRight: "8px",
  },
  actionBtnDelete: {
    display: "inline-flex", alignItems: "center", gap: "5px",
    padding: "6px 14px", background: "transparent",
    color: "#ef4444", border: "1px solid rgba(239,68,68,0.3)",
    borderRadius: "8px", fontSize: "12px", fontWeight: "600",
    cursor: "pointer", transition: "all 0.2s ease",
  },
  emptyIcon: { fontSize: "48px", opacity: 0.15, marginBottom: "16px" },
  emptyText: { fontSize: "14px", opacity: 0.4, fontWeight: "500" },
  attrChip: {
    display: "inline-block", padding: "2px 8px", margin: "0 4px 4px 0",
    background: "var(--body-color-less2)", borderRadius: "4px",
    fontSize: "11px", fontFamily: "monospace",
  },

  /* ── NEW MODAL STYLES ── */
  modalOverlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)",
    zIndex: 1050, display: "flex", alignItems: "flex-start",
    justifyContent: "center", overflowY: "auto", padding: "24px 16px",
  },
  modalBox: {
    background: "var(--body-color-less)", borderRadius: "20px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
    width: "100%", maxWidth: "680px",
    display: "flex", flexDirection: "column",
    animation: "modalSlideIn 0.22s ease",
  },
  modalHeader: {
    padding: "22px 28px 0",
    display: "flex", alignItems: "flex-start", justifyContent: "space-between",
  },
  modalTitleBlock: { flex: 1 },
  modalTitle: { fontSize: "20px", fontWeight: "700", margin: "0 0 4px", color: "var(--text-color)" },
  modalSubtitle: { fontSize: "13px", opacity: 0.45, margin: 0 },
  modalClose: {
    width: "34px", height: "34px", display: "flex", alignItems: "center",
    justifyContent: "center", borderRadius: "10px", border: "none",
    background: "var(--body-color-less2)", cursor: "pointer",
    fontSize: "16px", color: "var(--text-color)", opacity: 0.6,
    marginLeft: "16px", flexShrink: 0,
  },

  /* Step progress */
  stepBar: {
    display: "flex", alignItems: "center", gap: "0",
    padding: "20px 28px 0",
  },
  stepItem: (active, done) => ({
    display: "flex", alignItems: "center", gap: "8px",
    fontSize: "12px", fontWeight: done || active ? "700" : "500",
    color: done ? "#10b981" : active ? "var(--btn-color)" : "var(--text-color)",
    opacity: done || active ? 1 : 0.35,
    cursor: "default",
  }),
  stepCircle: (active, done) => ({
    width: "26px", height: "26px", borderRadius: "50%",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: "11px", fontWeight: "700",
    background: done ? "#10b981" : active ? "var(--btn-color)" : "var(--body-color-less2)",
    color: done || active ? "#fff" : "var(--text-color)",
    flexShrink: 0,
  }),
  stepConnector: (done) => ({
    flex: 1, height: "2px", margin: "0 8px",
    background: done ? "#10b981" : "var(--body-color-less2)",
    borderRadius: "2px",
  }),

  modalBody: { padding: "24px 28px" },

  /* Form elements */
  formRow: { display: "flex", gap: "16px", marginBottom: "18px", flexWrap: "wrap" },
  formGroup: { flex: 1, minWidth: "180px", display: "flex", flexDirection: "column" },
  formGroupFull: { width: "100%", display: "flex", flexDirection: "column", marginBottom: "18px" },
  label: {
    fontSize: "11px", fontWeight: "700", textTransform: "uppercase",
    letterSpacing: "0.4px", opacity: 0.55, marginBottom: "7px",
    display: "flex", alignItems: "center", gap: "5px",
  },
  requiredDot: { color: "var(--btn-color)", fontSize: "14px", lineHeight: 1 },
  input: {
    width: "100%", padding: "11px 14px", fontSize: "14px", borderRadius: "10px",
    border: "1.5px solid var(--body-color-less2)", background: "var(--body-color)",
    color: "var(--text-color)", outline: "none", boxSizing: "border-box",
    transition: "border-color 0.15s",
  },
  textarea: {
    width: "100%", padding: "11px 14px", fontSize: "14px", borderRadius: "10px",
    border: "1.5px solid var(--body-color-less2)", background: "var(--body-color)",
    color: "var(--text-color)", outline: "none", boxSizing: "border-box",
    minHeight: "90px", resize: "vertical", transition: "border-color 0.15s",
    fontFamily: "inherit",
  },
  select: {
    width: "100%", padding: "11px 14px", fontSize: "14px", borderRadius: "10px",
    border: "1.5px solid var(--body-color-less2)", background: "var(--body-color)",
    color: "var(--text-color)", outline: "none", boxSizing: "border-box",
    appearance: "auto", cursor: "pointer",
  },

  /* Image upload */
  uploadArea: {
    border: "2px dashed var(--body-color-less2)", borderRadius: "12px",
    padding: "28px 20px", textAlign: "center", cursor: "pointer",
    transition: "all 0.2s", background: "var(--body-color)",
    display: "flex", flexDirection: "column", alignItems: "center", gap: "8px",
  },
  uploadInput: { display: "none" },
  imagePreview: {
    width: "90px", height: "90px", borderRadius: "10px",
    objectFit: "cover", border: "2px solid var(--body-color-less2)",
  },

  /* Attributes ── NEW DESIGN */
  attrBuilderWrap: {
    background: "var(--body-color)", borderRadius: "14px",
    border: "1.5px solid var(--body-color-less2)", overflow: "hidden",
  },
  attrBuilderHeader: {
    padding: "14px 18px",
    borderBottom: "1px solid var(--body-color-less2)",
    display: "flex", alignItems: "center", justifyContent: "space-between",
  },
  attrBuilderTitle: { fontSize: "13px", fontWeight: "700", opacity: 0.7, margin: 0 },
  attrList: { padding: "12px 18px", display: "flex", flexDirection: "column", gap: "10px" },
  attrItemRow: {
    display: "flex", alignItems: "flex-start", gap: "12px",
    padding: "12px 14px", borderRadius: "10px",
    background: "var(--body-color-less)", border: "1px solid var(--body-color-less2)",
  },
  attrKeyBadge: {
    padding: "5px 12px", borderRadius: "6px", fontSize: "12px", fontWeight: "700",
    background: "color-mix(in srgb, var(--btn-color) 12%, transparent)",
    color: "var(--btn-color)", whiteSpace: "nowrap", flexShrink: 0,
    border: "1px solid color-mix(in srgb, var(--btn-color) 25%, transparent)",
  },
  attrValuesWrap: {
    flex: 1, display: "flex", flexWrap: "wrap", gap: "6px", alignItems: "center",
  },
  attrValuePill: {
    display: "inline-flex", alignItems: "center", gap: "5px",
    padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500",
    background: "var(--body-color-less2)", color: "var(--text-color)",
  },
  attrDeleteBtn: {
    background: "none", border: "none", cursor: "pointer",
    padding: "4px 6px", borderRadius: "6px",
    color: "#ef4444", opacity: 0.6, fontSize: "14px", flexShrink: 0,
    display: "flex", alignItems: "center",
  },
  attrEmptyMsg: {
    padding: "18px", textAlign: "center", fontSize: "13px",
    opacity: 0.35, fontStyle: "italic",
  },

  /* New attribute entry area */
  attrAddArea: {
    padding: "14px 18px", borderTop: "1px solid var(--body-color-less2)",
    background: "color-mix(in srgb, var(--btn-color) 4%, transparent)",
  },
  attrAddLabel: {
    fontSize: "11px", fontWeight: "700", textTransform: "uppercase",
    letterSpacing: "0.4px", opacity: 0.55, marginBottom: "10px", display: "block",
  },
  attrAddRow: { display: "flex", gap: "10px", alignItems: "flex-start" },
  attrKeyInput: {
    width: "150px", flexShrink: 0, padding: "9px 12px", fontSize: "13px",
    borderRadius: "8px", border: "1.5px solid var(--body-color-less2)",
    background: "var(--body-color)", color: "var(--text-color)", outline: "none",
  },
  attrValInput: {
    flex: 1, padding: "9px 12px", fontSize: "13px",
    borderRadius: "8px", border: "1.5px solid var(--body-color-less2)",
    background: "var(--body-color)", color: "var(--text-color)", outline: "none",
  },
  attrHint: { fontSize: "11px", opacity: 0.45, marginTop: "8px", lineHeight: "1.5" },
  pendingValChips: {
    display: "flex", flexWrap: "wrap", gap: "6px",
    marginTop: "8px", minHeight: "0",
  },
  pendingPill: {
    display: "inline-flex", alignItems: "center", gap: "5px",
    padding: "3px 10px", borderRadius: "20px", fontSize: "12px",
    background: "color-mix(in srgb, var(--btn-color) 15%, transparent)",
    color: "var(--btn-color)", border: "1px solid color-mix(in srgb, var(--btn-color) 30%, transparent)",
  },
  pillRemove: {
    cursor: "pointer", fontSize: "14px", lineHeight: 1,
    color: "var(--btn-color)", opacity: 0.7,
  },

  /* Modal footer */
  modalFooter: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "18px 28px", borderTop: "1px solid var(--body-color-less2)",
    gap: "12px",
  },
  btnBack: {
    padding: "10px 22px", background: "var(--body-color-less2)",
    color: "var(--text-color)", border: "none", borderRadius: "10px",
    fontSize: "13px", fontWeight: "600", cursor: "pointer",
  },
  btnNext: {
    padding: "10px 28px", background: "var(--btn-color)", color: "#fff",
    border: "none", borderRadius: "10px", fontSize: "13px",
    fontWeight: "600", cursor: "pointer",
  },
  btnCancel: {
    padding: "10px 22px", background: "rgba(239,68,68,0.1)", color: "#ef4444",
    border: "1px solid rgba(239,68,68,0.2)", borderRadius: "10px",
    fontSize: "13px", fontWeight: "600", cursor: "pointer",
  },

  /* Upload image modal */
  uModalHeader: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "20px 24px", borderBottom: "1px solid var(--body-color-less2)",
  },
  uModalTitle: { fontSize: "18px", fontWeight: "700", margin: 0 },
  uModalClose: {
    width: "32px", height: "32px", display: "flex",
    alignItems: "center", justifyContent: "center",
    borderRadius: "8px", border: "none", background: "var(--body-color-less2)",
    cursor: "pointer", fontSize: "18px", color: "var(--text-color)", opacity: 0.6,
  },
  uModalBody: { padding: "24px" },
  uModalFooter: {
    display: "flex", alignItems: "center", justifyContent: "flex-end",
    gap: "10px", padding: "16px 24px", borderTop: "1px solid var(--body-color-less2)",
  },
  btnSave: {
    padding: "10px 24px", background: "var(--btn-color)", color: "#fff",
    border: "none", borderRadius: "10px", fontSize: "13px",
    fontWeight: "600", cursor: "pointer",
  },
};

/* ─── Constants ─────────────────────────────────────────────────────────── */
const CURRENCIES = ["USD", "EUR", "GBP", "BTC", "ETH"];
const STEPS = ["Basic Info", "Pricing & Stock", "Attributes", "Image"];

const BLANK_PRODUCT = {
  productId: "", name: "", description: "",
  basePrice: "", currency: "USD", availableQuantity: "",
  attributes: {},
};

/* ─── Component ─────────────────────────────────────────────────────────── */
class MyCartProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      productList: [],
      totalCount: 0,

      // Add product modal
      showAddProductModal: false,
      modalStep: 1,           // 1-4
      newProduct: { ...BLANK_PRODUCT },

      // Attribute builder state
      draftAttrKey: "",
      draftAttrValues: [],    // chips waiting to be saved
      draftAttrValueInput: "",// current text in value input

      // Image
      uploadImage: null,
      uploadPreview: null,

      // Image upload modal (for existing products)
      showImageUploadModal: false,
      selectedProduct: null,
    };
  }

  /* ── Data fetching ──────────────────────────────────────────── */
  fetchProducts = () => {
    const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    if (!merchantId) { showToast("error", "Merchant ID not found"); return; }

    this.setState({ showLoader: true });
    GetAllProducts(merchantId)
      .then((res) => {
        this.setState({ showLoader: false });
        const response = res.data;
        if (response.status === "success") {
          this.setState({
            productList: response.data.products || [],
            totalCount: response.data.total || 0,
          });
        } else {
          showToast("error", response.message || "Failed to fetch products");
        }
      })
      .catch((err) => { this.setState({ showLoader: false }); showHttpError(err); });
  };

  componentDidMount() { this.fetchProducts(); }

  /* ── Modal open / close / reset ─────────────────────────────── */
  openAddModal = () => this.setState({
    showAddProductModal: true, modalStep: 1,
    newProduct: { ...BLANK_PRODUCT },
    draftAttrKey: "", draftAttrValues: [], draftAttrValueInput: "",
    uploadImage: null, uploadPreview: null,
  });

  closeAddModal = () => this.setState({ showAddProductModal: false });

  /* ── Step navigation ─────────────────────────────────────────── */
  nextStep = () => {
    const { modalStep, newProduct } = this.state;
    if (modalStep === 1) {
      if (!newProduct.productId.trim() || !newProduct.name.trim()) {
        showToast("error", "Product ID and Name are required"); return;
      }
    }
    if (modalStep === 2) {
      if (!newProduct.basePrice || !newProduct.availableQuantity) {
        showToast("error", "Price and Quantity are required"); return;
      }
    }
    this.setState({ modalStep: modalStep + 1 });
  };

  prevStep = () => this.setState({ modalStep: this.state.modalStep - 1 });

  /* ── Field changes ───────────────────────────────────────────── */
  handleProductChange = (field, value) =>
    this.setState({ newProduct: { ...this.state.newProduct, [field]: value } });

  /* ── Attribute builder ──────────────────────────────────────── */

  // Add a value chip to the draft list (on Enter or Add click)
  addDraftValue = () => {
    const { draftAttrValueInput, draftAttrValues } = this.state;
    const val = draftAttrValueInput.trim();
    if (!val) return;
    if (draftAttrValues.includes(val)) {
      showToast("error", "Value already added"); return;
    }
    this.setState({ draftAttrValues: [...draftAttrValues, val], draftAttrValueInput: "" });
  };

  removeDraftValue = (idx) =>
    this.setState({ draftAttrValues: this.state.draftAttrValues.filter((_, i) => i !== idx) });

  // Commit the draft key+values as an attribute
  commitAttribute = () => {
    const { draftAttrKey, draftAttrValues, draftAttrValueInput, newProduct } = this.state;

    // Flush any pending text that wasn't Enter-confirmed
    const finalValues = [...draftAttrValues];
    if (draftAttrValueInput.trim()) finalValues.push(draftAttrValueInput.trim());

    if (!draftAttrKey.trim()) { showToast("error", "Enter an attribute name (e.g. color)"); return; }
    if (finalValues.length === 0) { showToast("error", "Add at least one value"); return; }

    this.setState({
      newProduct: {
        ...newProduct,
        attributes: { ...newProduct.attributes, [draftAttrKey.trim()]: finalValues },
      },
      draftAttrKey: "", draftAttrValues: [], draftAttrValueInput: "",
    });
  };

  removeAttribute = (key) => {
    const attrs = { ...this.state.newProduct.attributes };
    delete attrs[key];
    this.setState({ newProduct: { ...this.state.newProduct, attributes: attrs } });
  };

  /* ── Image selection ─────────────────────────────────────────── */
  handleImageSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    this.setState({ uploadImage: file });
    const reader = new FileReader();
    reader.onloadend = () => this.setState({ uploadPreview: reader.result });
    reader.readAsDataURL(file);
  };

  /* ── Submit (step 4 → Create) ───────────────────────────────── */
  handleRegisterProduct = () => {
    const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    const { newProduct, uploadImage } = this.state;

    const cleanAttributes = {};
    Object.keys(newProduct.attributes).forEach((key) => {
      if (key.trim() && newProduct.attributes[key]?.length > 0)
        cleanAttributes[key] = newProduct.attributes[key];
    });

    const payload = {
      merchantId,
      products: [{
        productId: newProduct.productId,
        name: newProduct.name,
        description: newProduct.description || "",
        basePrice: parseFloat(newProduct.basePrice),
        currency: newProduct.currency,
        availableQuantity: parseInt(newProduct.availableQuantity),
        imageUrl: null,
        attributes: cleanAttributes,
      }],
    };

    this.setState({ showLoader: true });
    RegisterProducts(payload)
      .then((res) => {
        this.setState({ showLoader: false });
        const response = res.data;
        if (response.status === "success") {
          showToast("success", "Product created successfully!");
          this.closeAddModal();
          if (uploadImage) {
            this.handleUploadAfterRegister(newProduct.productId);
          } else {
            this.fetchProducts();
          }
        } else {
          showToast("error", response.message || "Failed to create product");
        }
      })
      .catch((err) => { this.setState({ showLoader: false }); showHttpError(err); });
  };

  handleUploadAfterRegister = (productId) => {
    const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    const { uploadImage } = this.state;
    const formData = new FormData();
    formData.append("merchantId", merchantId);
    formData.append("productId", productId);
    formData.append("image", uploadImage);
    UploadProductImage(productId, formData)
      .then(() => this.fetchProducts())
      .catch(() => this.fetchProducts());
  };

  /* ── Standalone image upload modal ──────────────────────────── */
  openImageUpload = (product) => this.setState({
    showImageUploadModal: true, selectedProduct: product,
    uploadImage: null, uploadPreview: null,
  });

  handleUploadImage = () => {
    const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    const { selectedProduct, uploadImage } = this.state;
    if (!uploadImage) { showToast("error", "No image selected"); return; }
    const formData = new FormData();
    formData.append("merchantId", merchantId);
    formData.append("productId", selectedProduct.productId);
    formData.append("image", uploadImage);
    this.setState({ showLoader: true });
    UploadProductImage(selectedProduct.productId, formData)
      .then((res) => {
        this.setState({ showLoader: false });
        const response = res.data;
        if (response.status === "success") {
          showToast("success", "Image uploaded successfully");
          this.setState({ showImageUploadModal: false, selectedProduct: null, uploadImage: null, uploadPreview: null });
          this.fetchProducts();
        } else {
          showToast("error", response.message || "Failed to upload image");
        }
      })
      .catch((err) => { this.setState({ showLoader: false }); showHttpError(err); });
  };

  handleEditProduct = (product) => showToast("info", "Edit functionality coming soon");

  handleDeleteProduct = (product) => {
    if (window.confirm(`Are you sure you want to delete "${product.name}"?`))
      showToast("success", "Product deleted (demo)");
  };

  /* ── Render helpers ──────────────────────────────────────────── */

  renderStep1() {
    const { newProduct } = this.state;
    return (
      <>
        <p style={{ fontSize: "13px", opacity: 0.5, marginBottom: "20px", marginTop: 0 }}>
          Enter the basic information about your product.
        </p>
        <div style={styles.formRow}>
          <div style={styles.formGroup}>
            <label style={styles.label}>
              Product ID <span style={styles.requiredDot}>*</span>
            </label>
            <input
              style={styles.input}
              placeholder="e.g. P001"
              value={newProduct.productId}
              onChange={(e) => this.handleProductChange("productId", e.target.value)}
            />
            <span style={{ fontSize: "11px", opacity: 0.4, marginTop: "5px" }}>A unique identifier for this product</span>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>
              Product Name <span style={styles.requiredDot}>*</span>
            </label>
            <input
              style={styles.input}
              placeholder="e.g. Wireless Headphones"
              value={newProduct.name}
              onChange={(e) => this.handleProductChange("name", e.target.value)}
            />
          </div>
        </div>
        <div style={styles.formGroupFull}>
          <label style={styles.label}>Description</label>
          <textarea
            style={styles.textarea}
            placeholder="Describe what makes this product great…"
            value={newProduct.description}
            onChange={(e) => this.handleProductChange("description", e.target.value)}
          />
        </div>
      </>
    );
  }

  renderStep2() {
    const { newProduct } = this.state;
    return (
      <>
        <p style={{ fontSize: "13px", opacity: 0.5, marginBottom: "20px", marginTop: 0 }}>
          Set the price and available stock quantity.
        </p>
        <div style={styles.formRow}>
          <div style={styles.formGroup}>
            <label style={styles.label}>
              Base Price <span style={styles.requiredDot}>*</span>
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              style={styles.input}
              placeholder="0.00"
              value={newProduct.basePrice}
              onChange={(e) => this.handleProductChange("basePrice", e.target.value)}
            />
          </div>
          <div style={{ ...styles.formGroup, maxWidth: "130px" }}>
            <label style={styles.label}>Currency</label>
            <select
              style={styles.select}
              value={newProduct.currency}
              onChange={(e) => this.handleProductChange("currency", e.target.value)}
            >
              {CURRENCIES.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>
              Available Quantity <span style={styles.requiredDot}>*</span>
            </label>
            <input
              type="number"
              min="0"
              style={styles.input}
              placeholder="0"
              value={newProduct.availableQuantity}
              onChange={(e) => this.handleProductChange("availableQuantity", e.target.value)}
            />
          </div>
        </div>

        {/* Preview card */}
        {newProduct.basePrice && (
          <div style={{
            marginTop: "8px", padding: "14px 18px", borderRadius: "12px",
            background: "color-mix(in srgb, var(--btn-color) 8%, transparent)",
            border: "1px solid color-mix(in srgb, var(--btn-color) 20%, transparent)",
            display: "flex", alignItems: "center", gap: "12px",
          }}>
            <i className="fas fa-tag" style={{ color: "var(--btn-color)", fontSize: "16px" }}></i>
            <span style={{ fontSize: "13px" }}>
              This product will be listed at{" "}
              <strong style={{ color: "var(--btn-color)", fontSize: "16px" }}>
                {parseFloat(newProduct.basePrice || 0).toFixed(2)} {newProduct.currency}
              </strong>
              {newProduct.availableQuantity && (
                <> with <strong>{newProduct.availableQuantity}</strong> units in stock</>
              )}
            </span>
          </div>
        )}
      </>
    );
  }

  renderStep3() {
    const { newProduct, draftAttrKey, draftAttrValues, draftAttrValueInput } = this.state;
    const savedAttrs = Object.entries(newProduct.attributes);

    return (
      <>
        <p style={{ fontSize: "13px", opacity: 0.5, marginBottom: "16px", marginTop: 0 }}>
          Attributes describe product variants like color or size. Each attribute has a name and one or more values.
        </p>

        <div style={styles.attrBuilderWrap}>
          {/* Saved attributes list */}
          <div style={styles.attrBuilderHeader}>
            <p style={styles.attrBuilderTitle}>
              {savedAttrs.length === 0 ? "No attributes yet" : `${savedAttrs.length} attribute${savedAttrs.length > 1 ? "s" : ""} added`}
            </p>
          </div>

          {savedAttrs.length === 0 ? (
            <p style={styles.attrEmptyMsg}>Add your first attribute below ↓</p>
          ) : (
            <div style={styles.attrList}>
              {savedAttrs.map(([key, values]) => (
                <div key={key} style={styles.attrItemRow}>
                  <span style={styles.attrKeyBadge}>{key}</span>
                  <div style={styles.attrValuesWrap}>
                    {(Array.isArray(values) ? values : [values]).map((v, i) => (
                      <span key={i} style={styles.attrValuePill}>{v}</span>
                    ))}
                  </div>
                  <button
                    type="button"
                    style={styles.attrDeleteBtn}
                    title="Remove attribute"
                    onClick={() => this.removeAttribute(key)}
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </div>
              ))}
            </div>
          )}

          {/* New attribute entry */}
          <div style={styles.attrAddArea}>
            <span style={styles.attrAddLabel}>Add an attribute</span>
            <div style={styles.attrAddRow}>
              <input
                style={styles.attrKeyInput}
                placeholder="Name (e.g. color)"
                value={draftAttrKey}
                onChange={(e) => this.setState({ draftAttrKey: e.target.value })}
              />
              <input
                style={styles.attrValInput}
                placeholder="Value (e.g. Red)"
                value={draftAttrValueInput}
                onChange={(e) => this.setState({ draftAttrValueInput: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === "Enter") { e.preventDefault(); this.addDraftValue(); }
                }}
              />
              <button
                type="button"
                style={{ ...styles.btnPrimary, padding: "9px 16px", fontSize: "12px", flexShrink: 0 }}
                onClick={this.addDraftValue}
              >
                <i className="fas fa-plus"></i> Add Value
              </button>
            </div>

            {/* Pending value chips */}
            {draftAttrValues.length > 0 && (
              <div style={styles.pendingValChips}>
                {draftAttrValues.map((v, i) => (
                  <span key={i} style={styles.pendingPill}>
                    {v}
                    <span style={styles.pillRemove} onClick={() => this.removeDraftValue(i)}>×</span>
                  </span>
                ))}
              </div>
            )}

            <p style={styles.attrHint}>
              {draftAttrValues.length === 0
                ? "Type a value and press Enter or click \"Add Value\" to stage it. Then click Save Attribute."
                : `${draftAttrValues.length} value${draftAttrValues.length > 1 ? "s" : ""} staged — add more or click Save Attribute.`}
            </p>

            <button
              type="button"
              style={{
                ...styles.btnNext,
                padding: "9px 20px", fontSize: "12px",
                opacity: (draftAttrKey.trim() && (draftAttrValues.length > 0 || draftAttrValueInput.trim())) ? 1 : 0.4,
              }}
              onClick={this.commitAttribute}
            >
              <i className="fas fa-check" style={{ marginRight: "6px" }}></i>
              Save Attribute
            </button>
          </div>
        </div>

        <p style={{ fontSize: "12px", opacity: 0.35, marginTop: "12px", marginBottom: 0 }}>
          <i className="fas fa-circle-info" style={{ marginRight: "5px" }}></i>
          Attributes are optional — you can skip this step.
        </p>
      </>
    );
  }

  renderStep4() {
    const { uploadPreview, newProduct } = this.state;
    return (
      <>
        <p style={{ fontSize: "13px", opacity: 0.5, marginBottom: "16px", marginTop: 0 }}>
          Upload a product image (optional). You can also add or change it later.
        </p>

        <div
          style={styles.uploadArea}
          onClick={() => document.getElementById("add-product-img").click()}
        >
          <input
            id="add-product-img"
            type="file"
            style={styles.uploadInput}
            accept="image/*"
            onChange={this.handleImageSelect}
          />
          {uploadPreview ? (
            <>
              <img src={uploadPreview} alt="Preview" style={styles.imagePreview} />
              <span style={{ fontSize: "12px", opacity: 0.5 }}>Click to change</span>
            </>
          ) : (
            <>
              <i className="fas fa-cloud-upload-alt" style={{ fontSize: "32px", opacity: 0.25 }}></i>
              <p style={{ margin: 0, fontSize: "13px", fontWeight: "600", opacity: 0.5 }}>Click to upload</p>
              <p style={{ margin: 0, fontSize: "12px", opacity: 0.35 }}>PNG, JPG, WEBP up to 5 MB</p>
            </>
          )}
        </div>

        {/* Summary review */}
        <div style={{
          marginTop: "20px", padding: "16px 18px", borderRadius: "12px",
          background: "var(--body-color)", border: "1.5px solid var(--body-color-less2)",
        }}>
          <p style={{ margin: "0 0 10px", fontSize: "12px", fontWeight: "700", opacity: 0.45, textTransform: "uppercase", letterSpacing: "0.4px" }}>
            Review Summary
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 20px", fontSize: "13px" }}>
            <span style={{ opacity: 0.5 }}>Product ID</span><strong>{newProduct.productId}</strong>
            <span style={{ opacity: 0.5 }}>Name</span><strong>{newProduct.name}</strong>
            <span style={{ opacity: 0.5 }}>Price</span><strong>{newProduct.basePrice} {newProduct.currency}</strong>
            <span style={{ opacity: 0.5 }}>Stock</span><strong>{newProduct.availableQuantity} units</strong>
            <span style={{ opacity: 0.5 }}>Attributes</span>
            <strong>{Object.keys(newProduct.attributes).length > 0 ? Object.keys(newProduct.attributes).join(", ") : "None"}</strong>
          </div>
        </div>
      </>
    );
  }

  /* ── Main render ─────────────────────────────────────────────── */
  render() {
    const { productList, showAddProductModal, modalStep, showImageUploadModal, selectedProduct } = this.state;

    return (
      <Fragment>
        {/* Keyframe injection */}
        <style>{`
          @keyframes modalSlideIn {
            from { opacity: 0; transform: translateY(-18px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          .product-input:focus { border-color: var(--btn-color) !important; }
        `}</style>

        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={styles.pageWrapper}>

              {/* Page header */}
              <div style={styles.headerRow}>
                <PageHeader
                  icon="mdi-cart"
                  title="My Cart Products"
                  subtitle={
                    <>
                      Manage your product catalog for PayBito checkout
                      {this.state.totalCount > 0 && (
                        <span style={{ marginLeft: "8px", fontWeight: "600" }}>
                          · {this.state.totalCount} total
                        </span>
                      )}
                    </>
                  }
                />
                <button style={styles.btnPrimary} type="button" onClick={this.openAddModal}>
                  <i className="fas fa-plus" style={{ fontSize: "12px" }}></i>
                  Add New Product
                </button>
              </div>

              {/* Table */}
              <div style={styles.card}>
                <div style={styles.tableWrapper}>
                  <table style={styles.table}>
                    <thead>
                      <tr>
                        {["Image", "Product ID", "Name", "Price", "Stock", "Status", "Attributes", "Created", "Actions"].map((h) => (
                          <th key={h} style={{ ...styles.th, textAlign: h === "Actions" ? "center" : "left" }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {productList && productList.length > 0 ? (
                        productList.map((product) => (
                          <tr key={product.productId}>
                            <td style={styles.td}>
                              {product.imageUrl ? (
                                <img
                                  src={product.imageUrl}
                                  alt={product.name}
                                  style={styles.productImage}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                    e.target.parentNode.innerHTML = '<div style="width:40px;height:40px;border-radius:8px;background:var(--body-color-less2);display:flex;align-items:center;justify-content:center;font-size:18px;">📦</div>';
                                  }}
                                />
                              ) : (
                                <div style={styles.productImagePlaceholder}>📦</div>
                              )}
                            </td>
                            <td style={{ ...styles.td, fontFamily: "monospace", fontWeight: "600" }}>{product.productId}</td>
                            <td style={{ ...styles.td, fontWeight: "600" }}>
                              {product.name}
                              {product.description && (
                                <div style={{ fontSize: "11px", opacity: 0.45, marginTop: "2px" }}>
                                  {product.description.substring(0, 30)}{product.description.length > 30 ? "…" : ""}
                                </div>
                              )}
                            </td>
                            <td style={{ ...styles.td, fontFamily: "monospace", fontWeight: "600" }}>
                              {formatAmount(product.basePrice, 2)} {product.currency}
                            </td>
                            <td style={styles.td}>
                              <span style={{
                                color: product.availableQuantity > 10 ? "#10b981" : product.availableQuantity > 0 ? "#f59e0b" : "#ef4444",
                                fontWeight: "600",
                              }}>{product.availableQuantity}</span>
                            </td>
                            <td style={styles.td}>
                              <span style={styles.statusBadge(product.status || "ACTIVE")}>
                                <span style={styles.statusDot(product.status || "ACTIVE")}></span>
                                {product.status || "ACTIVE"}
                              </span>
                            </td>
                            <td style={styles.td}>
                              {product.attributes && Object.keys(product.attributes).length > 0 ? (
                                <div style={{ maxWidth: "200px" }}>
                                  {Object.entries(product.attributes).map(([key, values]) => (
                                    <span key={key} style={styles.attrChip}>
                                      {key}: {Array.isArray(values) ? values.join(", ") : values}
                                    </span>
                                  ))}
                                </div>
                              ) : <span style={{ opacity: 0.3 }}>—</span>}
                            </td>
                            <td style={{ ...styles.td, fontSize: "11px", opacity: 0.5 }}>
                              {product.createdAt ? <Moment format="MMM DD, YYYY" date={product.createdAt} /> : "—"}
                            </td>
                            <td style={{ ...styles.td, textAlign: "center" }}>
                              <button style={styles.actionBtnEdit} type="button" onClick={() => this.handleEditProduct(product)}>
                                <i className="fas fa-pen" style={{ fontSize: "11px" }}></i> Edit
                              </button>
                              <button style={{ ...styles.btnSecondary, marginLeft: "8px" }} type="button" onClick={() => this.openImageUpload(product)}>
                                <i className="fas fa-image" style={{ fontSize: "11px" }}></i> Upload
                              </button>
                              <button style={{ ...styles.actionBtnDelete, marginLeft: "8px" }} type="button" onClick={() => this.handleDeleteProduct(product)}>
                                <i className="fas fa-trash" style={{ fontSize: "11px" }}></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" style={{ textAlign: "center", padding: "60px 20px" }}>
                            <div style={styles.emptyIcon}><i className="fas fa-box-open"></i></div>
                            <p style={styles.emptyText}>No products found. Click "Add New Product" to get started.</p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Footer />
          </div>

          {/* ──────────────────────────────────────────────────────────── */}
          {/* Add Product Modal  (custom, replaces react-bootstrap Modal) */}
          {/* ──────────────────────────────────────────────────────────── */}
          {showAddProductModal && (
            <div style={styles.modalOverlay} onClick={(e) => e.target === e.currentTarget && this.closeAddModal()}>
              <div style={styles.modalBox}>

                {/* Header */}
                <div style={styles.modalHeader}>
                  <div style={styles.modalTitleBlock}>
                    <h3 style={styles.modalTitle}>Add New Product</h3>
                    <p style={styles.modalSubtitle}>Step {modalStep} of {STEPS.length} — {STEPS[modalStep - 1]}</p>
                  </div>
                  <button style={styles.modalClose} onClick={this.closeAddModal} type="button">
                    <i className="fas fa-xmark"></i>
                  </button>
                </div>

                {/* Step progress bar */}
                <div style={styles.stepBar}>
                  {STEPS.map((label, i) => {
                    const num = i + 1;
                    const active = num === modalStep;
                    const done = num < modalStep;
                    return (
                      <Fragment key={label}>
                        <div style={styles.stepItem(active, done)}>
                          <div style={styles.stepCircle(active, done)}>
                            {done ? <i className="fas fa-check" style={{ fontSize: "10px" }}></i> : num}
                          </div>
                          <span>{label}</span>
                        </div>
                        {i < STEPS.length - 1 && <div style={styles.stepConnector(done)}></div>}
                      </Fragment>
                    );
                  })}
                </div>

                {/* Body — step content */}
                <div style={styles.modalBody}>
                  {modalStep === 1 && this.renderStep1()}
                  {modalStep === 2 && this.renderStep2()}
                  {modalStep === 3 && this.renderStep3()}
                  {modalStep === 4 && this.renderStep4()}
                </div>

                {/* Footer */}
                <div style={styles.modalFooter}>
                  <button
                    style={styles.btnCancel}
                    type="button"
                    onClick={this.closeAddModal}
                  >
                    Cancel
                  </button>
                  <div style={{ display: "flex", gap: "10px" }}>
                    {modalStep > 1 && (
                      <button style={styles.btnBack} type="button" onClick={this.prevStep}>
                        <i className="fas fa-arrow-left" style={{ marginRight: "6px", fontSize: "11px" }}></i>
                        Back
                      </button>
                    )}
                    {modalStep < STEPS.length ? (
                      <button style={styles.btnNext} type="button" onClick={this.nextStep}>
                        Next
                        <i className="fas fa-arrow-right" style={{ marginLeft: "6px", fontSize: "11px" }}></i>
                      </button>
                    ) : (
                      <button style={styles.btnNext} type="button" onClick={this.handleRegisterProduct}>
                        <i className="fas fa-check" style={{ marginRight: "6px", fontSize: "11px" }}></i>
                        Create Product
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ── Image Upload Modal (existing products) ── */}
          <Modal
            show={showImageUploadModal}
            backdrop="static"
            size="md"
            keyboard={false}
            onHide={() => this.setState({ showImageUploadModal: false })}
          >
            <div style={styles.uModalHeader}>
              <h3 style={styles.uModalTitle}>Upload Product Image</h3>
              <button type="button" style={styles.uModalClose} onClick={() => this.setState({ showImageUploadModal: false })}>
                <i className="fas fa-xmark"></i>
              </button>
            </div>
            <div style={styles.uModalBody}>
              {selectedProduct && (
                <p style={{ marginBottom: "16px", fontSize: "14px" }}>
                  Uploading image for: <strong>{selectedProduct.name}</strong>
                </p>
              )}
              <div style={styles.uploadArea} onClick={() => document.getElementById("modal-image-upload").click()}>
                <input
                  id="modal-image-upload"
                  type="file"
                  style={styles.uploadInput}
                  accept="image/*"
                  onChange={this.handleImageSelect}
                />
                {this.state.uploadPreview ? (
                  <>
                    <img src={this.state.uploadPreview} alt="Preview" style={styles.imagePreview} />
                    <span style={{ fontSize: "12px", opacity: 0.5 }}>Click to change</span>
                  </>
                ) : (
                  <>
                    <i className="fas fa-cloud-upload-alt" style={{ fontSize: "32px", opacity: 0.25 }}></i>
                    <p style={{ margin: 0, fontSize: "13px", opacity: 0.5 }}>Click to select an image</p>
                  </>
                )}
              </div>
            </div>
            <div style={styles.uModalFooter}>
              <button style={styles.btnCancel} type="button" onClick={() => this.setState({ showImageUploadModal: false })}>
                Cancel
              </button>
              <button
                style={{ ...styles.btnSave, ...(!this.state.uploadImage ? { opacity: 0.45, cursor: "not-allowed" } : {}) }}
                type="button"
                onClick={this.handleUploadImage}
                disabled={!this.state.uploadImage}
              >
                Upload Image
              </button>
            </div>
          </Modal>

          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default withRouter(MyCartProducts);